import { useLocation } from 'react-router';
import CogIcon from '../../../assets/components/CogIcon';
import DashboardIcon from '../../../assets/components/DashboardIcon';
import GiftIcon from '../../../assets/components/GiftIcon';
import LogoutIcon from '../../../assets/components/LogoutIcon';
import ReceiptIcon from '../../../assets/components/ReceiptIcon';
import UserMultipleCircleIcon from '../../../assets/components/UserMultipleCircleIcon';
import ItemSidebar from './ItemSidebar';
import {
  ADMIN_HOME,
  ADMIN_LINK,
  ADMIN_PERSONALIZE,
  ADMIN_PRODUCTS,
  ADMIN_SETTING,
  ADMIN_SYSTEM_JOBS,
  ADMIN_USERS,
  HOME,
} from '../../../routes/app/paths';

import { Link } from 'react-router-dom';
import SVGLogo from '../../../assets/svg/logo.svg';

const ServerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="20" height="20">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z" />
  </svg>
);

const navItems = [
  {
    name: 'Dashboard',
    path: ADMIN_HOME,
    icon: <DashboardIcon />,
  },
  {
    name: 'Productos',
    path: ADMIN_PRODUCTS,
    icon: <GiftIcon />,
  },
  {
    name: 'Usuarios',
    path: ADMIN_USERS,
    icon: <UserMultipleCircleIcon />,
  },
  {
    name: 'Links de pago',
    path: ADMIN_LINK,
    icon: <ReceiptIcon />,
  },
  {
    name: 'Personalizar',
    path: ADMIN_PERSONALIZE,
    icon: <DashboardIcon />,
  },
];

const navItemsSeconds = [
  {
    name: 'Configuración',
    path: ADMIN_SETTING,
    icon: <CogIcon />,
  },
  {
    name: 'Salir',
    path: 'logout',
    icon: <LogoutIcon />,
  },
];

const SidebarAdmin = () => {
  const location = useLocation();

  return (
    <div className="w-[240px] h-full px-8 flex flex-col items-center justify-between select-none">
      {/* Top elements */}
      <div className="flex flex-col gap-8 py-16 w-full items-center">
        <Link to={HOME} className="flex flex-shrink-0 ml-3 lg:ml-0 items-center gap-2">
          {/* SVG Logo */}
          <img
            className="-m-1 sm:-m-1.5 p-1 sm:p-1.5 w-8 lg:w-10 aspect-auto"
            alt="logo"
            src={SVGLogo}
          />
          <span className="text-xl lg:text-2xl text-primary font-light">TropiPhone</span>
        </Link>

        {/* nav */}
        <div className="flex flex-col w-full text-base gap-5">
          {navItems.map((item, index) => (
            <ItemSidebar
              key={`sidebar-${index}`}
              path={item.path}
              title={item.name}
              icon={item.icon}
              active={location.pathname === item.path}

            />
          ))}

          {/* Sección Sistema */}
          <div className="text-xs text-gray-400 uppercase tracking-wider px-1 mt-2">Sistema</div>
          <ItemSidebar
            path={ADMIN_SYSTEM_JOBS}
            title="Jobs"
            icon={<ServerIcon />}
            active={location.pathname === ADMIN_SYSTEM_JOBS}
          />
        </div>
      </div>

      {/* Bottom elements nav */}
      <div className="flex flex-col w-full text-base gap-2 mb-7">
        {navItemsSeconds.map((item, index) => (
          <ItemSidebar
            key={`sidebar-${index}`}
            path={item.path}
            title={item.name}
            icon={item.icon}
            active={location.pathname === item.path}
          />
        ))}
      </div>
    </div>
  );
};
export default SidebarAdmin;
